/**
 * RHFRules allows for common rules to be easily applied to common TextField types
 */
export const RHFRules = {
    phoneNumber: {
        validate: {
            isPhoneFormat: (v) => {
                if (!v)
                    return;
                const re = /^\+\d{11}$/;
                const validated = String(v).match(re);
                if (!validated)
                    return 'Must be a valid phone number, e.g. (555) 867-5309';
                return true;
            },
            minLength: (v) => {
                if (!v)
                    return;
                if (v.length !== 12) {
                    return 'Valid phone number must be at least 10 digits.';
                }
                return true;
            },
        },
    },
    email: {
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Invalid email address',
        },
    },
    timePicker: {
        validate: {
            isDate: (v) => {
                if (!v)
                    return true;
                if (!(v instanceof Date)) {
                    return 'Must be hh:mm AM/PM';
                }
                return true;
            },
        },
    },
};
//# sourceMappingURL=rhf-helpers.js.map